import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import './App.css';

import AboutMe from './components/AboutMe';
import PictureSlider from './components/PictureSlider';
import CursorPixie from './components/CursorPixie';


import Services, { services } from './components/Services';
import Reviews from './components/Reviews';




function App() {
  const navigate = useNavigate();
  const [selectedServiceIndex, setSelectedServiceIndex] = useState(null);
  const lockedBookingServices = React.useMemo(
    () => new Set(['House Sitting', 'Dog Walking', 'Drop-In Visits', 'Pet Day Care']),
    []
  );

  const handleBookNow = () => {
    const selectedService =
      selectedServiceIndex !== null ? services[selectedServiceIndex] : null;

    if (!selectedService?.title) {
      alert('Please select a service before booking.');
      return;
    }

    if (selectedService?.title) {
      const shouldLockService = lockedBookingServices.has(selectedService.title);
      const lockSuffix = shouldLockService ? '&locked=1' : '';
      navigate(`/book?service=${encodeURIComponent(selectedService.title)}${lockSuffix}`);
      return;
    }
  };

  return (
    <div className="App">
      <CursorPixie />
      <div className="banner">
        <div className="banner-contact" aria-label="Contact information">
          <a className="banner-contact-link" href="tel:+17379006174">
            <span className="icon-phone" aria-hidden="true" />
            <span>+1 (737) 900-6174</span>
          </a>
          <a className="banner-contact-link" href="mailto:allthingsxkay@gmail.com">
            <span className="icon-mail" aria-hidden="true" />
            <span>allthingsxkay@gmail.com</span>
          </a>
        </div>
        <h1 className="shimmer-text">AllThingsXKay</h1>
      </div>
      <Services
        selectedIndex={selectedServiceIndex}
        onSelectService={setSelectedServiceIndex}
      />
      <div className="book-now-wrap">
        <button className="book-now-btn" onClick={handleBookNow}>
          Book Now
        </button>
      </div>
      <AboutMe />
      <PictureSlider />
      <Reviews />
    </div>
  );
}

export default App;
